module.exports = __webpack_public_path__ + "static/img/avatar.cc483264.png";